import Vue from 'vue';
import Router from 'vue-router';
import login from '@/components/login';
import home from '@/components/home';
import main from '@/components/main';
import notFound from '@/components/404';
import allCars from '@/components/cars-location/all-cars';
import carTracing from '@/components/cars-location/car-tracing';
import mobileTrajectory from '@/components/cars-location/mobile-trajectory';

import realtimeStatus from '@/components/battery-status/realtime-status';
import historyStatus from '@/components/battery-status/history-status';
import historyCurve from '@/components/battery-status/history-curve';

import accessManagement from '@/components/account-management/access-management';
import personalCenter from '@/components/account-management/personal-center';
import userManagement from '@/components/account-management/user-management';

import carsInfo from '@/components/info-management/cars-info';
import energyAnalysis from '@/components/data-analysis/energy-analysis';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            hidden: true,
            name: 'login',
            component: login
        },
        {
            path: '/404',
            hidden: true,
            name: '404',
            component: notFound
        },
        {
            path: '/',
            name: 'home',
            component: home,
            children: [
                {
                    path: '/main',
                    name: 'main',
                    component: main
                },
                {
                    path: '/all-cars',
                    name: 'all-cars',
                    component: allCars,
                    menu: true
                },
                {
                    path: '/car-tracing',
                    name: 'car-tracing',
                    component: carTracing
                },
                {
                    path: '/mobile-trajectory',
                    name: 'mobile-trajectory',
                    component: mobileTrajectory
                },
                {
                    path: '/cars-info',
                    name: 'cars-info',
                    component: carsInfo
                },
                {
                    path: '/energy-analysis',
                    name: 'energy-analysis',
                    component: energyAnalysis
                },
                {
                    path: '/realtime-status',
                    name: 'realtime-status',
                    component: realtimeStatus
                },
                {
                    path: '/history-status',
                    name: 'history-status',
                    component: historyStatus
                },
                {
                    path: '/history-curve',
                    name: 'history-curve',
                    component: historyCurve
                },
                {
                    path: '/access-management',
                    name: 'access-management',
                    component: accessManagement
                },
                {
                    path: '/personal-center',
                    name: 'personal-center',
                    component: personalCenter
                },
                {
                    path: '/user-management',
                    name: 'user-management',
                    component: userManagement
                },
                {
                    path: '*',
                    hidden: true,
                    redirect: { path: '/main' }
                }
            ]
        },
        {
            path: '*',
            hidden: true,
            redirect: { path: '/404' }
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js